import React from 'react'
import { Tooltip } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { scroller } from 'react-scroll'

import { NumberInput } from '@/modules/base/components/inputs'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import ThemeInterface from '@/theme-interface'
import IconArrowLeft from '@assets/images/icons/arrow_left.svg'
import IconArrowRight from '@assets/images/icons/arrow_right.svg'
import lang from '@/lang'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  pager: {
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'row nowrap',
    gap: 5,
    maxWidth: 250,
    margin: '0 auto',
    marginBottom: 20,
    fontSize: theme.fontSizes.small,
    height: 30,
  },
  pagerInput: {
    width: 50,
    display: 'flex',
    alignItems: 'center',
    maxHeight: 20,
    maxWidth: 30,
    fontSize: theme.fontSizes.small,
  },
  pagerInputInput: {
    height: 26,
    width: 26,
    fontSize: theme.fontSizes.small,
    textAlign: 'center',
    paddingLeft: 0,
  },
  tooltip: {
    fontSize: theme.fontSizes.tooltip,
  },
  button: {
    background: 'transparent',
    border: 0,
    outline: 'none',
    cursor: 'pointer',
    transition: 'fill 0.3s ease',
    '&:disabled': {
      cursor: 'unset',
      opacity: 0.5,
      '&:hover': {
        '& svg': {
          fill: theme.disabledColor,
        },
      },
    },
    '&:hover': {
      '& svg': {
        fill: theme.primaryLight,
      },
    },

  },
}))

const Pager = ({ currentPage, pageCount, setCurrentPage }) => {
  const classes = useStyles()

  const scrollToWithContainer = (page) => {
    if (page > pageCount || page < 1) {
      return
    }
    setCurrentPage(page)
    scroller.scrollTo(`page-${page}`, {
      duration: 800,
      smooth: 'easeInOutQuart',
      offset: -40,
      containerId: 'containerElement',
    })
  }

  return (
    <div className={classes.pager}>
      <Tooltip title={lang.list.previousPage} classes={{ tooltip: classes.tooltip }}>
        <div>
          <button
            className={classes.button}
            onClick={() => scrollToWithContainer(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <SVGIcon svg={IconArrowLeft} height={'12'} width={'12'} />
          </button>
        </div>
      </Tooltip>
      Seite <NumberInput
        customClass={classes.pagerInput}
        inputClassName={classes.pagerInputInput}
        useFormik={false}
        defaultValue={currentPage}
        onBlur={(value) => scrollToWithContainer(value)}
      /> <span>von {pageCount}</span>
      <Tooltip title={lang.list.nextPage} classes={{ tooltip: classes.tooltip }}>
        <div>
          <button
            className={classes.button}
            onClick={() => scrollToWithContainer(currentPage + 1)}
            disabled={currentPage === pageCount}
          >
            <SVGIcon svg={IconArrowRight} height={12} width={12} />
          </button>
        </div>
      </Tooltip>
    </div>
  )
}

export default Pager
